import { render, staticRenderFns } from "./internal-document.vue?vue&type=template&id=0f794eb8&scoped=true&"
import script from "./internal-document.vue?vue&type=script&lang=js&"
export * from "./internal-document.vue?vue&type=script&lang=js&"
import style0 from "./internal-document.vue?vue&type=style&index=0&id=0f794eb8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f794eb8",
  null
  
)

export default component.exports